import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { selectAccountBalance, selectAccountId, selectAccountInterests, selectAutoInvest, toggleAutoInvestActions } from '../../../features/auth/ducks';
import { createAllocationActions } from '../ducks';
import { apiCallIds } from '../api';
import { allocationType, settingKeys } from '../../../common/enums';
import CreateAutomaticAllocation from '../components/CreateAutomaticAllocation';
import { selectSetting, selectSettingNumeric } from '../../../features/settings/ducks';
import config from '../../../config';
import SignAllocation from '../components/SignAllocation';
import ConfirmAllocation from '../components/ConfirmAllocation';

const mapStateToProps = state => {
  return ({
    accountId: selectAccountId(state),
    accountBalance: selectAccountBalance(state),
    isCreating: selectIsInProgress(state, apiCallIds.CREATE_ALLOCATION),
    defaultMonths: selectSettingNumeric(state, settingKeys.CREDITOR_CALCULATOR_DEFAULT_MONTHS),
    interestRange: selectAccountInterests(state),
    minMonths: selectSettingNumeric(state, settingKeys.LOAN_MIN_MONTHS),
    maxMonths: selectSettingNumeric(state, settingKeys.LOAN_MAX_MONTHS),
    autoinvest: selectAutoInvest(state)
  })
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      createAllocation: createAllocationActions.request,
      toggleAutoInvest: toggleAutoInvestActions.request
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class CreateAutomaticAllocationContainer extends Component {
  static propTypes = {
    accountBalance: PropTypes.number.isRequired,
    accountId: PropTypes.string.isRequired,
    isCreating: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    defaultMonths: PropTypes.number.isRequired,
    interestRange: PropTypes.array.isRequired,
  };

  onSubmit = (allocationData, toggle) => {
    const { accountId, actions,  } = this.props;

    // actions.createAllocation({
    //   allocation: {
    //     ...allocationData,
    //     allocationType: allocationType.AUTOMATIC,
    //   },
    //   accountId,
    // });
    actions.toggleAutoInvest({ accountId: accountId, data: {...allocationData}, toggle: toggle })
  };

  render() {
    const { accountBalance, isCreating, defaultMonths, interestRange, minMonths, maxMonths, autoinvest, accountId } = this.props;

    //const { calculatorMonthsMin, calculatorMonthsMax, calculatorMonthsStep } = config;
    const calculatorMonthsMin = minMonths
    const calculatorMonthsMax = maxMonths
    const calculatorMonthsStep = 1
    return (
      <div>
        <SignAllocation />
        {/* <ConfirmAllocation isAllocation /> */}
        <CreateAutomaticAllocation
          isCreating={isCreating}
          accountBalance={accountBalance}
          onSubmit={this.onSubmit}
          calculatorMonthsMin={calculatorMonthsMin}
          calculatorMonthsMax={calculatorMonthsMax}
          calculatorMonthsStep={calculatorMonthsStep}
          defaultMonths={defaultMonths}
          interestRange={interestRange}
          autoinvest={autoinvest}
          accountId={accountId}
        />
      </div>
      
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/allocations/containers/CreateAutomaticAllocationContainer.js